module.exports = __webpack_public_path__ + "static/neighborhoods-desktop.9c89cb8a.webp";